"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
export const Menu = forwardRef((props, ref) => {
  const { expanded, children } = props;
  const className = classNames("menu", { expanded });
  return /* @__PURE__ */ jsx("div", { ref, tabIndex: -1, className, children });
});
